module.exports = __webpack_public_path__ + "static/media/logo.0e180c6e.png";